import { render, staticRenderFns } from "./MentionNotification.vue?vue&type=template&id=71b9ddea&scoped=true&"
import script from "./MentionNotification.vue?vue&type=script&lang=js&"
export * from "./MentionNotification.vue?vue&type=script&lang=js&"
import style0 from "./MentionNotification.vue?vue&type=style&index=0&id=71b9ddea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9ddea",
  null
  
)

export default component.exports